<div class="content-section">
    <div class="row">
        <div class="col left"></div>
        <div class="col right top-buttons">
            <button type="button" [ngStyle]="{ 'margin-right.px': 10 }" [disabled]="preventativeHold==true" tsl-button
                size="small" color="blue" filled class="nav-item nav-link-edit"
                *ngIf="tabPermissions?.contact == 'ReadWrite'" (click)="openDialog(null)"
                i18n="@@b61d69b3b6afe9bb7600aa9b56046a44fedbcb02" t="b61d69b3b6afe9bb7600aa9b56046a44fedbcb02">
                Add Email domain
            </button>
        </div>
    </div>
    <div>
        <table tsl-table [dataSource]="gridViewData">
            <ng-container tslColumnDef="domain">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@af800c79ccd70992229fb5972331a4ed2ccadd95"
                    t="af800c79ccd70992229fb5972331a4ed2ccadd95">
                    Domain
                </th>
                <td tsl-cell *tslCellDef="let element">
                    <div *ngIf="element?.domain?.newValue; else empty">
                        {{ element?.domain?.newValue }}
                    </div>
                </td>
            </ng-container>

            <ng-container tslColumnDef="reason">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@14ef407153eff028f94080077aca1c9555f5422b"
                    t="14ef407153eff028f94080077aca1c9555f5422b">
                    Reason
                </th>
                <td tsl-cell *tslCellDef="let element">
                    <div *ngIf="element?.reason?.newValue; else empty">
                        {{ element?.reason?.newValue }}
                    </div>
                </td>
            </ng-container>

            <ng-container tslColumnDef="website">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@807b2535b8c37b131279771e75076bdcef4d5ce0"
                    t="807b2535b8c37b131279771e75076bdcef4d5ce0">
                    Website
                </th>
                <td tsl-cell *tslCellDef="let element">
                    <div *ngIf="element?.website?.newValue; else empty">
                        {{ element?.website?.newValue }}
                    </div>
                </td>
            </ng-container>

            <ng-container tslColumnDef="documents">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@Documents" t="Documents">Documents</th>
                <td tsl-cell *tslCellDef="let element">
                    <div *ngIf="element?.documents?.newValue?.length > 0; else empty"></div>
                </td>
            </ng-container>

            <ng-container tslColumnDef="action">
                <th tsl-header-cell *tslHeaderCellDef i18n="@@01a32bb7e93373cbc305329319efc67c0bd85226"
                    t="01a32bb7e93373cbc305329319efc67c0bd85226">
                    Action
                </th>
                <td tsl-cell *tslCellDef="let element" class="actions icons" width="8%">
                    <div *ngIf="
                            element.operation.newValue ||
                                (canChangeItem(element) && element.operation?.newValue !== 'Delete') ||
                                (canChangeItem(element) && element.operation?.newValue !== 'Delete');
                            else empty
                        ">
                        <div *ngIf="element.operation.newValue">
                            <div class="task-status">
                                <tsl-chip [ngClass]="statusClass['Under Tesla Review']">
                                    {{ translate.get(statusDisplay['Under Tesla Review']) }}
                                </tsl-chip>
                            </div>
                        </div>
                        <button tsl-icon-button [disabled]="preventativeHold==true"
                            *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                            (click)="openDialog(element)">
                            <tsl-icon status="primary">edit</tsl-icon>
                        </button>
                        <button tsl-icon-button [disabled]="preventativeHold==true"
                            *ngIf="canChangeItem(element) && element.operation?.newValue !== 'Delete'"
                            (click)="deleteItem(element)">
                            <tsl-icon status="error">delete</tsl-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr tsl-header-row *tslHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

            <ng-template #empty>
                <tsl-icon>maximize</tsl-icon>
            </ng-template>
        </table>

        <div>
            <tsl-pagination [pageSizeOptions]="pageSizeOptions" showFirstLastButtons (pageChange)="pageChange($event)"
                [total]="totalRows" [pageSize]="currentPageSize"
                [itemsPerPageLabel]="translate.get('ItemsPerPage')"></tsl-pagination>
        </div>
    </div>
</div>